namespace TabAurous.Sales {
    export namespace OpenConsignmentOutDetailedService {
        export const baseUrl = 'Sales/OpenConsignmentOutDetailed';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<Reports.StockBifurcationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Sales/OpenConsignmentOutDetailed/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OpenConsignmentOutDetailedService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
